import { RouteRecordRaw } from "vue-router";
import { LAYOUT, ManagerType } from "../constants";

export default {
  path: "/detail",
  name: "Detail",
  component: LAYOUT,
  meta: {
    hideMenu: true,
  },
  children: [
    {
      path: "/team/detail/:id",
      name: "TeamDetailPage",
      component: () => import("@/views/team/TeamDetailPage.vue"),
      meta: {
        title: "队伍详情",
        roles: ManagerType.OrganizationReviewer,
      },
    },
    {
      path: "/player/detail/:idNumber",
      name: "PlayerDetailPage",
      component: () => import("@/views/player/PlayerDetailPage.vue"),
      meta: {
        title: "运动员详情",
      },
    },
    {
      path: "/player/detail/personal/:id",
      name: "PersonalPlayerDetailPage",
      component: () => import("@/views/personal/PlayerDetailPage.vue"),
      meta: {
        title: "个人运动员详情",
      },
    },
  ],
} as RouteRecordRaw;
